(async () => {
  if (!customElements.get('product-recommendations')) {
    const { default: Swiper, Navigation, A11y } = await import('swiper');

    Swiper.use([Navigation, A11y]);

    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-swiper]');

        this.swiperOptions = {
          threshold: 10,
          a11y: true,
          slidesPerView: 1.5,
          spaceBetween: 8,
          navigation: {
            nextEl: '.swiper-button-next--recom',
            prevEl: '.swiper-button-prev--recom',
          },
          breakpoints: {
            480: {
              slidesPerView: 2.5,
            },
            600: {
              slidesPerView: 3,
            },
            1024: {
              slidesPerView: 4,
            },
          },
        };

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions,
            };
          }
        }

        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

        // Only do it once, not on every web component render.
        window.onload = () => {
          this.init();
          this.handleSwiperButtons();
          window.addEventListener('resize', () => {
            this.handleSwiperButtons();
          });
        };
      }

      handleSwiperButtons() {
        const windowWidth = window.innerWidth;
        if (windowWidth > 600) {
          this.querySelectorAll('button').forEach((button) => button.classList.remove('hidden'));
        } else if (this.swiperInstance) {
          this.querySelectorAll('button').forEach((button) => button.classList.add('hidden'));
        }
      }

      init() {
        if (this.dataset && this.dataset.url) {
          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const source = html.querySelector('[data-recommended-products]');
              const target = this.querySelector('[data-recommended-products]');

              if (source && source.innerHTML && source.innerHTML.trim().length) {
                target.innerHTML = source.innerHTML;
              }

              this.swiperInstance.update();
            })
            .catch((error) => {
              console.error(error);
            });
        }
      }
    }

    window.ProductRecommendations = ProductRecommendations;

    customElements.define('product-recommendations', ProductRecommendations);
  }
})();
